import React from "react";

import CheckboxListQuestion from "../CheckboxListQuestion/CheckboxListQuestion";

const CheckboxListCardsQuestion = props => {
  return <CheckboxListQuestion {...props} useCard noLabel />
};

export default CheckboxListCardsQuestion;

